import { render } from "./tabs.vue?vue&type=template&id=518e9a4d"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"

import "./tabs.vue?vue&type=style&index=0&id=518e9a4d&lang=css"
script.render = render

export default script